import { Button, List, Popover, Badge, Tag } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { IconBell, IconNotification } from "@tabler/icons-react";
import useGetApi from "../../hooks/useGetApi";
import usersApis from "../../api/methods/users";
import moment from "moment";
import appColors from "../../theme/common/colors";
import { useMutation } from "@tanstack/react-query";

interface Notification {
  id: number;
  avatar: string;
  content: string;
  created_at: string;
  is_read: string;
}

const AppNotifications: React.FC = () => {
  const {
    data: unreadNotifications,
    isLoading,
    refetch,
  } = useGetApi(usersApis().getUnreadNotifications);
  let notifications = unreadNotifications?.results || [];

  const { mutate: notificationsread } = useMutation({
    mutationFn: usersApis().readnotification.mf,
    mutationKey: usersApis().readnotification.mk,
    onSuccess: () => {
      refetch();
    },
  });

  const handleRefresh = () => {
    refetch();
  };

  const content = (
    <div className="p-0 bg-white rounded-lg w-[420px] max-h-[500px] overflow-y-auto">
      <div className="flex justify-between items-center mb-1 px-2">
        <h2 className="text-xl font-medium">Notifications</h2>
        <Button
          type="link"
          icon={<ReloadOutlined spin={isLoading} />}
          onClick={handleRefresh}
        ></Button>
      </div>
      <List
        loading={isLoading}
        itemLayout="horizontal"
        dataSource={notifications}
        renderItem={(item: Notification) => (
          <List.Item
            className="cursor-pointer hover:bg-gray-100 rounded-md px-2"
            onClick={() => {
              notificationsread({ id: item.id });
            }}
          >
            <List.Item.Meta
              avatar={
                <div className="p-3 bg-[#f5f5f5] rounded-[100px]">
                  <IconNotification color={appColors.primary} />
                </div>
              }
              title={
                <div className="flex justify-between items-center">
                  <p className="font-medium">{item.content}</p>

                  {item.is_read ? (
                    <Tag color="green">Read</Tag>
                  ) : (
                    <Tag color="red">Unread</Tag>
                  )}
                </div>
              }
              description={moment(item.created_at).format("MM/DD/YYYY hh:mm A")}
            />
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <Popover content={content} trigger="click">
      <Button type="text">
        <Badge count={notifications.length}>
          <IconBell strokeWidth={1.3} />
        </Badge>
      </Button>
    </Popover>
  );
};

export default AppNotifications;
